/* ═══════════════════════════════════════════════════
   AEB Silver — Theme JavaScript
   Handles: collection filtering, story banners, mobile menu, photo and video gallery
   ═══════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function() {

  /* ── HOMEPAGE FILTER TABS + COLLECTION BANNERS ── */
  var filterTabs = document.getElementById('filterTabs');
  var productGrid = document.getElementById('productGrid');
  var itemCount = document.getElementById('itemCount');
  var bannersContainer = document.getElementById('collectionBanners');

  if (filterTabs && productGrid) {
    var tabs = filterTabs.querySelectorAll('.filter-tab');
    var cards = productGrid.querySelectorAll('.product-card');
    var banners = bannersContainer
      ? bannersContainer.querySelectorAll('.collection-story')
      : [];

    // Check for a default collection set in theme settings
    var filterBar = document.querySelector('.filter-bar');
    var defaultCollection = filterBar
      ? filterBar.getAttribute('data-default-collection')
      : 'all';

    function activateFilter(filter) {
      var visibleCount = 0;

      // Update active tab
      tabs.forEach(function(t) { t.classList.remove('active'); });
      tabs.forEach(function(t) {
        if (t.getAttribute('data-filter') === filter) {
          t.classList.add('active');
        }
      });

      // Filter product cards
      cards.forEach(function(card) {
        var collections = (card.getAttribute('data-collections') || '').split(',');
        var show = false;

        if (filter === 'all') {
          show = true;
        } else if (collections.indexOf(filter) !== -1) {
          show = true;
        }

        if (show) {
          card.classList.remove('hidden');
          card.style.animationDelay = (visibleCount * 0.04) + 's';
          card.style.animation = 'none';
          card.offsetHeight;
          card.style.animation = '';
          visibleCount++;
        } else {
          card.classList.add('hidden');
        }
      });

      if (itemCount) {
        itemCount.textContent = visibleCount;
      }

      // Show/hide collection story banners
      banners.forEach(function(banner) {
        var bannerCollection = banner.getAttribute('data-collection');
        if (bannerCollection === filter) {
          banner.style.display = 'block';
          banner.style.opacity = '0';
          banner.style.transform = 'translateY(-8px)';
          requestAnimationFrame(function() {
            banner.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
            banner.style.opacity = '1';
            banner.style.transform = 'translateY(0)';
          });
        } else {
          banner.style.display = 'none';
        }
      });
    }

    // Attach click handlers to all tabs
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        activateFilter(tab.getAttribute('data-filter'));
      });
    });

    // Stagger initial card animations
    cards.forEach(function(card, index) {
      card.style.animationDelay = (index * 0.04) + 's';
    });

    // Apply default collection on page load
    if (defaultCollection && defaultCollection !== 'all' && defaultCollection !== '') {
      activateFilter(defaultCollection);
    } else {
      // Just set the count for "Everything"
      if (itemCount) {
        itemCount.textContent = cards.length;
      }
    }
  }


  /* ── MOBILE NAV ── */
  var menuToggle = document.querySelector('.menu-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  var mobileOverlay = document.querySelector('.mobile-nav-overlay');
  var mobileClose = document.querySelector('.mobile-nav-close');

  if (menuToggle && mobileNav && mobileOverlay) {
    function openMenu() {
      mobileNav.classList.add('is-open');
      mobileOverlay.classList.add('is-open');
      document.body.classList.add('menu-open');
    }

    function closeMenu() {
      mobileNav.classList.remove('is-open');
      mobileOverlay.classList.remove('is-open');
      document.body.classList.remove('menu-open');
    }

    menuToggle.addEventListener('click', openMenu);
    mobileOverlay.addEventListener('click', closeMenu);

    if (mobileClose) {
      mobileClose.addEventListener('click', closeMenu);
    }

    mobileNav.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        closeMenu();
      }
    });
  }


  /* ── PRODUCT PAGE GALLERY: photos and videos ── */
  var mainImage = document.getElementById('mainImage');
  var mainVideo = document.getElementById('mainVideo');
  var thumbs = document.querySelectorAll('.gallery-thumb');
  var prevBtn = document.getElementById('galleryPrev');
  var nextBtn = document.getElementById('galleryNext');
  var counterEl = document.getElementById('galleryCounter');
  var currentIndex = 0;

  if (thumbs.length > 0 && (mainImage || mainVideo)) {
    var totalItems = thumbs.length;

    // Take the video out of the main view, which also stops it playing
    function clearVideo() {
      if (!mainVideo) return;
      mainVideo.innerHTML = '';
      mainVideo.hidden = true;
    }

    function goToItem(index) {
      // Wrap around
      if (index < 0) index = totalItems - 1;
      if (index >= totalItems) index = 0;
      currentIndex = index;

      var thumb = thumbs[currentIndex];
      var template = thumb.querySelector('template');

      if (thumb.getAttribute('data-type') === 'video' && template && mainVideo) {
        // A video: its player is kept in the thumbnail's <template> until it is wanted
        clearVideo();
        mainVideo.appendChild(template.content.cloneNode(true));
        mainVideo.hidden = false;
        if (mainImage) mainImage.hidden = true;
      } else {
        clearVideo();
        if (mainImage) {
          mainImage.src = thumb.getAttribute('data-src');
          mainImage.alt = thumb.getAttribute('data-alt') || '';
          mainImage.hidden = false;
        }
      }

      // Update active thumb
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');

      // Scroll active thumb into view
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

      // Update counter
      if (counterEl) {
        counterEl.textContent = (currentIndex + 1) + ' / ' + totalItems;
      }
    }

    // Thumbnail clicks
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var idx = parseInt(thumb.getAttribute('data-index'), 10);
        goToItem(idx);
      });
    });

    // Arrow clicks
    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        goToItem(currentIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        goToItem(currentIndex + 1);
      });
    }

    // Keyboard arrow navigation when on product page. Inside a video the arrow
    // keys belong to the player (they move through the video).
    document.addEventListener('keydown', function(e) {
      if (e.target && e.target.tagName === 'VIDEO') return;
      if (e.key === 'ArrowLeft') goToItem(currentIndex - 1);
      if (e.key === 'ArrowRight') goToItem(currentIndex + 1);
    });

    // A product whose first item is a video opens on it
    if (thumbs[0].getAttribute('data-type') === 'video') {
      goToItem(0);
    }
  }

});
